import {Switch} from '@wandb/weave/components';
import React, {useState} from 'react';

import {SettingTitle} from '../common/SettingTitle';
import {useMediaSettingsDrawerContext} from '../MediaSettingsDrawerContextProvider';

export const OriginalSize = () => {
  const {config, updateConfig, unsetConfigField} =
    useMediaSettingsDrawerContext();
  const [shouldUseOriginalSize, setShouldUseOriginalSize] = useState(
    config.actualSize
  );
  return (
    <div className="flex justify-between">
      <SettingTitle
        title="Use original size"
        configField="actualSize"
        unsetConfigField={() => unsetConfigField('actualSize')}
      />
      <Switch.Root
        aria-label="Toggle use original size"
        data-test="original-size-switch"
        checked={shouldUseOriginalSize}
        onCheckedChange={newValue => {
          setShouldUseOriginalSize(newValue);
          // Allow the switch to animate before updating the config so that it's more of a smooth
          // transition before the component re-mounts
          setTimeout(() => {
            updateConfig({actualSize: newValue, fitToDimension: false});
          }, 100);
        }}>
        <Switch.Thumb checked={shouldUseOriginalSize} />
      </Switch.Root>
    </div>
  );
};
